module.exports = __webpack_public_path__ + "img/Small-Vertical-Rectangular-Attachment-42.0ca2f239.png";